module.exports = __webpack_public_path__ + "img/2014E015_covid_7-6-2021.50005a25.jpg";